import {Backbone} from 'FWBackbone';
import _ from 'underscore';
import config from 'config';

global.FWCartEvents = _.extend({}, Backbone.Events);
global.saveTimeout = null;

class CartManager{

  static reset(){
    localStorage.removeItem('fw-order');
    localStorage.removeItem('fw-products');
  }

  static async createOrder() {
    const order = CartManager.getOrder();
    if (order && !order.completed) {
      return order;
    } else {
      return $.post(config.API_ROOT + '/cart/create-order', {
        items: this.getSelectedProducts()
      }).then((r) => {
        return CartManager.saveOrder(r.order);
      });
    }
  }

  static saveOrder(order){
    localStorage.setItem('fw-order', JSON.stringify(order));
    return order;
  }

  static getOrder() {
    return JSON.parse(localStorage.getItem('fw-order'));
  }

  static showQuantity(product) {
    return product.productType !== 'file' && product.productType !== 'media_series';
  }

  static updateQuantity(productId, qty) {
    let products = CartManager.getSelectedProducts() || [];
    let product = _.findWhere(products, {productId: productId});
    let index = _.indexOf(products, product);
    products[index].qty = parseInt(qty);
    CartManager.saveSelectedProducts(products);
    FWCartEvents.trigger('change');
  }

  static removeProduct = function(productId) {
    let products = CartManager.getSelectedProducts() || [];
    let product = _.findWhere(products, {productId: productId});
    products = _.without(products, product);
    CartManager.saveSelectedProducts(products);
    FWCartEvents.trigger('change');
  };

  static addProduct = function({
    productName,
    productPrice,
    productType,
    productId,
    image
  }){
    let products = CartManager.getSelectedProducts() || [];

    let product = _.findWhere(products, {productId: productId});
    if (product && (productType === 'file' || productType === 'media_series')) {
      return;
    }
    if (product) {
      let index = _.indexOf(products, product);
      product.qty = product.qty + 1;
      products[index] = product;
    } else {
      products.push({
        productName, productPrice, productType, productId, image, qty: 1
      });
    }
    CartManager.saveSelectedProducts(products);
    FWCartEvents.trigger('change');
  }

  static clearPurchased = function() {
    const products = JSON.parse(localStorage.getItem('fw-products') || '[]');

    console.log('PRODUCTS: ', products);

    const p = _.map(products, (pp) => {
    //  console.log('PRODUCT: ', pp);
    });

/*
    const user = FW.store.get('user');
    console.log('USER: ', user.get('purchased_files'), user.get('purchased_series'));*/
  }

  static getSelectedProducts = function() {
    CartManager.clearPurchased();
    const products = localStorage.getItem('fw-products') || '[]';
    return JSON.parse(products);
  }

  static saveSelectedProducts = function(products) {
    const productString = JSON.stringify(products);
    localStorage.setItem('fw-products', productString);
    clearTimeout(global.saveTimeout);
    global.saveTimeout = setTimeout(() => {
      $.ajax({
        url: config.API_ROOT + '/cart/save',
        dataType: 'json',
        method: 'post',
        data: JSON.stringify({
          products: products
        }),
        contentType: 'application/json'
      }).then((r) => {
        console.log('RESULT ', r);
      });
    }, 500);
  }

}

export {CartManager};
